<template>
  <div class="container">
    <div class="main-content-text">
      <span class="update">Last updated: June 2025</span>
      <h1 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Privacy Policy</h1>
      <p>
        At <strong>MyCelebrity</strong> by <strong>Digitalentio</strong> (“we”, “our”, “us”), we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website <strong>www.mycelebrity.in</strong>, or engage with our services.
      </p>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">1. Information We Collect</h3>
      <p>We may collect the following types of personal and business information:</p>
      <ul>
        <li>Name, email address, phone number, company name</li>
        <li>Social media handles (for influencer/celebrity onboarding)</li>
        <li>Brand and campaign requirements</li>
        <li>Billing and payment details (if applicable)</li>
        <li>Any data voluntarily submitted through forms, email, or WhatsApp</li>
      </ul>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">2. How We Use Your Information</h3>
      <p>We use your data to:</p>
      <ul>
        <li>Respond to inquiries and provide services</li>
        <li>Match brands with relevant influencers or celebrities</li>
        <li>Create and manage marketing campaigns</li>
        <li>Communicate about projects, updates, and offers</li>
        <li>Improve our services and user experience</li>
      </ul>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">3. Data Sharing & Disclosure</h3>
      <p>We do not sell your personal data. However, we may share it with:</p>
      <ul>
        <li>Internal team members for project execution</li>
        <li>Partners or influencers involved in campaigns</li>
        <li>Legal or government authorities, if required by law</li>
      </ul>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">4. Data Security</h3>
      <p>
        We implement appropriate security measures to protect your information from unauthorized access, misuse, or disclosure.
      </p>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">5. Cookies & Tracking</h3>
      <p>
        Our website may use cookies or analytics tools to monitor performance, traffic, and user behavior. You can adjust your browser settings to refuse cookies if you prefer.
      </p>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">6. Third-Party Links</h3>
      <p>
        Our website or communication may include links to third-party platforms (e.g., Instagram, YouTube). We are not responsible for their privacy practices.
      </p>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">7. Your Rights</h3>
      <p>
        You may request to access, correct, or delete your personal information by contacting us directly.
      </p>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">8. Contact Us</h3>
      <p>
        If you have any questions about this Privacy Policy or our data practices, contact:
      </p>
      <ul>
        <li>📧 branding@digitalentio.com</li>
        <li>📱 +91 9113229933</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style lang="scss" scoped>
.main-content-text {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 15px;
  }

  h1 {
    font-size: 30px;
  }

  h2 {
    font-size: 26px;
  }

  h3 {
    font-size: 22px;
    font-weight: 600;
  }

  h4 {
    font-size: 22px;
  }

  h5 {
    font-size: 20px;
  }

  h6 {
    font-size: 18px;
  }

  .gap-20 {
    margin-bottom: 30px;
  }

  p {
    color: #687693;
  }

  ul {
    padding-left: 20px;
    margin-bottom: 20px;

    li {
      margin-bottom: 10px;
      color: var(--BodyColor);

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  ol {
    padding-left: 18px;
    color: var(--bodyColor);

    li {
      margin-bottom: 20px;
      color: var(--bodyColor);

      &::marker {
        color: var(--mainColor);
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  a {
    color: var(--mainColor);

    &:hover {
      text-decoration: underline;
    }
  }

  .content-gap-mb-20 {
    margin-bottom: 20px;
  }

  .content-gap-mb-30 {
    margin-bottom: 30px;
  }

  .update {
    display: block;
    margin-bottom: 30px;
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .main-content-text {
    h3 {
      font-size: 20px;
    }
  }
}
</style>
